module.exports = __webpack_public_path__ + "static/media/sport-p.be96c08c.mp3";